import { observer } from 'mobx-react';
import { WoundOrderEditWoundDetailsViewStore } from '../stores';
import { setCurrentView } from 'core/utils';
import React from 'react';
import { WoundOrderEditWoundDetailsTemplate } from 'themes/application/wound-order/pages';

@setCurrentView((rootStore) => new WoundOrderEditWoundDetailsViewStore(rootStore), 'woundOrderEditWoundDetailsViewStore')
@observer
class WoundOrderEditWoundDetailsPage extends React.Component {
    render(){
        return <WoundOrderEditWoundDetailsTemplate {...this.props} />
    }
}

export default WoundOrderEditWoundDetailsPage;